// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ng-dialog/css/ngDialog-theme-plain.css
// module id = YksY
// module chunks = 1 2